import { ApplicationConfig, importProvidersFrom, PLATFORM_ID, isDevMode } from '@angular/core';
import { provideRouter, RouterModule, UrlSerializer, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withFetch } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { urlSerializerFactory } from './urlserializaion';
import { scrollTopService } from './scrolltop.service';
import { GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule } from '@abacritt/angularx-social-login';
import { environment } from '../environments/environment';
import { DecimalPipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { HttpInterceptorService } from '../shared/services/http-interceptor.service';
import { SchemaService } from '../shared/services/schema.service';
import { ServerSideResponseService } from '../shared/services/server-response-service.service';
// import { SwUpdate, provideServiceWorker } from '@angular/service-worker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LimitNumberDirective } from '../shared/directives/limit-number.directive';
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM/YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
export const appConfig: ApplicationConfig = {
  providers: [provideHttpClient(withFetch()),scrollTopService,provideRouter(routes, withComponentInputBinding()), provideClientHydration(), importProvidersFrom(HttpClientModule,MatDialogModule, BrowserAnimationsModule,), provideAnimationsAsync(),
    {
        provide: 'SocialAuthServiceConfig',
        useValue: {
            autoLogin: false,
            providers: [
                {
                    id: GoogleLoginProvider.PROVIDER_ID,
                    provider: new GoogleLoginProvider(environment.googleProvider)
                }
            ],
            onError: (err: any) => { }
        } as SocialAuthServiceConfig,
    },
    ServerSideResponseService,
    DecimalPipe,
    // SocialAuthService,
    LimitNumberDirective,
    // SwUpdate,
    SchemaService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    {
        provide: 'SocialAuthServiceConfig',
        useValue: {
            autoLogin: false,
            providers: [
                {
                    id: GoogleLoginProvider.PROVIDER_ID,
                    provider: new GoogleLoginProvider(environment.googleProvider)
                }
            ],
            onError: (err: any) => { }
        } as SocialAuthServiceConfig,
    },
    {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    { provide: 'googleTagManagerId', useValue: 'AW-852878965' },
    //  provideServiceWorker('ngsw-worker.js', {
    //     enabled: !isDevMode(),
    //     registrationStrategy: 'registerWhenStable:30000'
    // }), 
    // provideServiceWorker('ngsw-worker.js', {
    //     enabled: !isDevMode(),
    //     registrationStrategy: 'registerWhenStable:30000'
    // }), 
    provideAnimationsAsync()],
  
};
